import React, {useEffect, useMemo, useState} from 'react';
import {get} from '../../../api/api';
import './styles.scss';
import * as fonts from '../../../util/fonts';
import {strings} from '../../../util/strings';
import {connect} from 'react-redux';
import {Row} from '../../../components/layout';
import Header1 from '../../../components/headers/header1';
import {uriMediktor} from '../../../api/endpoints';
import Bubble from '../bubble';
import ModalTemplate from '../../../components/modal';
import AppButton from '../../../components/app-button';
import colors from '../../../util/colors';
import {labelsParagraphs} from '../../../util/utility';
import AppParagraph from '../../../components/app-paragraph';
import AuthorizedImage from '../../../components/images';
import AppSpinner from '../../../components/app-spinner';

interface ServiceDetailsModalProps {
  user: any;
  selectedBu: any;
  show: boolean;
  setShow: any;
  serviceDetails: any;
  globalStyles: any;
  labels: typeof strings.pt.services;
}

function ServiceDetailsModal({
  user,
  selectedBu,
  show,
  setShow,
  serviceDetails,
  globalStyles,
  labels,
}: ServiceDetailsModalProps) {
  const [mediktorUrl, setMediktorUrl] = useState('');
  const [showMediktorError, setShowMediktorError] = useState(false);
  const [content, setContent] = useState(false);
  const [mediktorSelected, setMediktorSelected] = useState(false);

  const featureName = 'Services';

  // converts any '\r\n' in the labels to "<p></p>"
  labelsParagraphs(labels);

  const memoizedUrlExists = useMemo(() => {
    return (url: string) => {
      if (url) {
        var http = new XMLHttpRequest();
        http.open('HEAD', url, false);
        try {
          http.send();
        } catch (err: any) {}
        if (http.status !== 404) return url;
        else return null;
      } else return null;
    };
  }, []);

  const calculatedUrl = useMemo(() => {
    return serviceDetails?.buServiceDetails?.find(
      (detail: any) => detail.languageAlias === user.language
    )?.buttonUrl;
  }, [serviceDetails, user.language]);

  const hrefUrl = useMemo(() => {
    if (
      serviceDetails?.buttonVisible &&
      serviceDetails?.buttonType === 'link' &&
      memoizedUrlExists(
        serviceDetails?.authenticationMedictor ? mediktorUrl : calculatedUrl
      )
    ) {
      return serviceDetails?.authenticationMedictor
        ? mediktorUrl
        : calculatedUrl;
    }

    return;
  }, [serviceDetails, mediktorUrl, calculatedUrl, memoizedUrlExists]);

  useEffect(() => {
    if (
      serviceDetails &&
      serviceDetails?.buttonType === 'link' &&
      serviceDetails?.authenticationMedictor
    ) {
      getMediktorInfo();
      setMediktorSelected(true);
    } else {
      setMediktorSelected(false);
    }
    setContent(true);
  }, [serviceDetails]);

  useEffect(() => {
    setShowMediktorError(false);
  }, [selectedBu?.buId, serviceDetails?.id]);

  const getMediktorInfo = async () => {
    try {
      await get(
        uriMediktor(selectedBu.buId, selectedBu.memId),
        false,
        0,
        featureName
      ).then((res: any) => {
        if (res?.data && res?.data?.url) {
          setMediktorUrl(res?.data?.url);
          setShowMediktorError(false);
        } else {
          setShowMediktorError(true);
        }
      });
    } catch (err: any) {
      setShowMediktorError(true);
    }
  };

  return (
    <>
      <ModalTemplate
        show={show}
        cross={true}
        onHide={() => {
          setContent(false);
          setShow(false);
        }}
        size="xl"
        hideFooter={true}
        centered={false}>
        {content && serviceDetails ? (
          <Row className="service-details-modal-container">
            <Row className="service-details-title">
              <Header1
                className="service-details-heading1"
                style={{...fonts.XL, ...fonts.Bold}}>
                {
                  serviceDetails?.buServiceDetails?.find(
                    (detail: any) => detail.languageAlias === user.language
                  )?.serviceName
                }
              </Header1>
            </Row>
            <Row className="service-details-images-display-container">
              <Bubble
                classNames={'service-details-images-display'}
                height={'180px'}
                width={'180px'}
              />
              <AuthorizedImage
                source={`${process.env.REACT_APP_BASE_BACKOFFICE_IMAGES_URL}${
                  serviceDetails?.buServiceDetails?.find(
                    (detail: any) => detail.languageAlias === user.language
                  )?.image
                }`}
                className="service-details-images-display"
              />
            </Row>
            <Row className="service-details-info-container">
              <div
                className="service-details-subtitle"
                style={{...fonts.ML, ...fonts.SemiBold}}>
                {
                  serviceDetails?.buServiceDetails?.find(
                    (detail: any) => detail.languageAlias === user.language
                  )?.subtitle
                }
              </div>
              <div className="service-subtitle-container">
                {serviceDetails?.buttonVisible &&
                  (serviceDetails?.buttonType === 'link' ? (
                    <a
                      style={{color: colors.white}}
                      href={hrefUrl || undefined}
                      target="_blank">
                      <AppButton
                        className="service-details-button"
                        disabled={showMediktorError}>
                        {
                          serviceDetails?.buServiceDetails?.find(
                            (detail: any) =>
                              detail.languageAlias === user.language
                          )?.buttonText
                        }
                      </AppButton>
                    </a>
                  ) : serviceDetails?.buttonType === 'telefone' ||
                    serviceDetails?.buttonType === 'phone' ? (
                    <a
                      style={{color: colors.white}}
                      href={`tel:${serviceDetails?.labelsFrontend?.buttonText}`}>
                      <AppButton className="service-details-button">
                        {
                          serviceDetails?.buServiceDetails?.find(
                            (detail: any) =>
                              detail.languageAlias === user.language
                          )?.buttonText
                        }
                      </AppButton>
                    </a>
                  ) : serviceDetails?.buttonType === 'e-mail' ||
                    serviceDetails?.buttonType === 'email' ? (
                    <a
                      style={{color: colors.white}}
                      href={`mailto:${
                        serviceDetails?.buServiceDetails?.find(
                          (detail: any) =>
                            detail.languageAlias === user.language
                        )?.buttonUrl
                      }`}>
                      <AppButton className="service-details-button">
                        {
                          serviceDetails?.buServiceDetails?.find(
                            (detail: any) =>
                              detail.languageAlias === user.language
                          )?.buttonText
                        }
                      </AppButton>
                    </a>
                  ) : (
                    <AppButton className="service-details-button">
                      {
                        serviceDetails?.buServiceDetails?.find(
                          (detail: any) =>
                            detail.languageAlias === user.language
                        )?.buttonText
                      }
                    </AppButton>
                  ))}
              </div>
              {/*mediktor Selected to prevent the error to appear in renders of this modal that are not "Avaliador de sintomas"*/}
              {showMediktorError && mediktorSelected && (
                <p
                  className="service-details-error"
                  style={{...fonts.M, ...fonts.Medium, color: colors.alertRed}}>
                  {labels?.services_mediktor_error}
                </p>
              )}
              {serviceDetails?.buServiceDetails?.find(
                (detail: any) => detail.languageAlias === user.language
              )?.buttonLegend && (
                <p
                  className="service-details-buttonLegend"
                  style={{...fonts.M, ...fonts.Light}}>
                  {
                    serviceDetails?.buServiceDetails?.find(
                      (detail: any) => detail.languageAlias === user.language
                    )?.buttonLegend
                  }
                </p>
              )}

              {serviceDetails?.buServiceDetails?.find(
                (detail: any) => detail.languageAlias === user.language
              )?.bellowButtonTitle && (
                <p
                  className="service-details-bellowButtonTitle"
                  style={{...fonts.M, ...fonts.Medium, fontSize: '16px'}}>
                  {
                    serviceDetails?.buServiceDetails?.find(
                      (detail: any) => detail.languageAlias === user.language
                    )?.bellowButtonTitle
                  }
                </p>
              )}

              {serviceDetails?.buServiceDetails?.find(
                (detail: any) => detail.languageAlias === user.language
              )?.bellowButtonBlueText && (
                <p
                  className="service-details-bellowButtonBlueText"
                  style={{
                    ...fonts.M,
                    ...fonts.SemiBold,
                    color: globalStyles.primaryColor,
                    fontSize: '18px',
                    marginTop: '-10px',
                  }}>
                  {
                    serviceDetails?.buServiceDetails?.find(
                      (detail: any) => detail.languageAlias === user.language
                    )?.bellowButtonBlueText
                  }
                </p>
              )}

              {serviceDetails?.buServiceDetails?.find(
                (detail: any) => detail.languageAlias === user.language
              )?.bellowButtonNote && (
                <p
                  className="service-details-bellowButtonNote"
                  style={{
                    ...fonts.M,
                    ...fonts.Medium,
                    fontSize: '16px',
                  }}>
                  {
                    serviceDetails?.buServiceDetails?.find(
                      (detail: any) => detail.languageAlias === user.language
                    )?.bellowButtonNote
                  }
                </p>
              )}

              {serviceDetails?.buServiceDetails?.find(
                (detail: any) => detail.languageAlias === user.language
              )?.descriptionTitle1 && (
                <p
                  className="service-details-description-titles"
                  style={{...fonts.MM, ...fonts.SemiBold}}>
                  {
                    serviceDetails?.buServiceDetails?.find(
                      (detail: any) => detail.languageAlias === user.language
                    )?.descriptionTitle1
                  }
                </p>
              )}

              {serviceDetails?.buServiceDetails?.find(
                (detail: any) => detail.languageAlias === user.language
              )?.description1 && (
                <AppParagraph
                  className="service-details-descriptions"
                  style={{...fonts.MM, ...fonts.Light}}
                  label={serviceDetails?.buServiceDetails
                    ?.find(
                      (detail: any) => detail.languageAlias === user.language
                    )
                    ?.description1?.replaceAll('\r\n', '<p></p>')}
                />
              )}

              {serviceDetails?.buServiceDetails?.find(
                (detail: any) => detail.languageAlias === user.language
              )?.descriptionTitle2 && (
                <p
                  className="service-details-description-titles"
                  style={{...fonts.MM, ...fonts.SemiBold}}>
                  {
                    serviceDetails?.buServiceDetails?.find(
                      (detail: any) => detail.languageAlias === user.language
                    )?.descriptionTitle2
                  }
                </p>
              )}

              {serviceDetails?.buServiceDetails?.find(
                (detail: any) => detail.languageAlias === user.language
              )?.description2 && (
                <AppParagraph
                  className="service-details-description-titles"
                  style={{...fonts.MM, ...fonts.Light}}
                  label={serviceDetails?.buServiceDetails
                    ?.find(
                      (detail: any) => detail.languageAlias === user.language
                    )
                    ?.description2?.replaceAll('\r\n', '<p></p>')}
                />
              )}

              {serviceDetails?.buServiceDetails?.find(
                (detail: any) => detail.languageAlias === user.language
              )?.descriptionTitle3 && (
                <p
                  className="service-details-descriptions"
                  style={{...fonts.MM, ...fonts.SemiBold}}>
                  {
                    serviceDetails?.buServiceDetails?.find(
                      (detail: any) => detail.languageAlias === user.language
                    )?.descriptionTitle3
                  }
                </p>
              )}

              {serviceDetails?.buServiceDetails?.find(
                (detail: any) => detail.languageAlias === user.language
              )?.description3 && (
                <AppParagraph
                  className="service-details-description-titles"
                  style={{...fonts.MM, ...fonts.Light}}
                  label={serviceDetails?.buServiceDetails
                    ?.find(
                      (detail: any) => detail.languageAlias === user.language
                    )
                    ?.description3?.replaceAll('\r\n', '<p></p>')}
                />
              )}

              {serviceDetails?.buServiceDetails?.find(
                (detail: any) => detail.languageAlias === user.language
              )?.legalText && (
                <p
                  className="service-details-legalText"
                  style={{...fonts.M, ...fonts.Light}}>
                  {
                    serviceDetails?.buServiceDetails?.find(
                      (detail: any) => detail.languageAlias === user.language
                    )?.legalText
                  }
                </p>
              )}
            </Row>
          </Row>
        ) : (
          <AppSpinner className="spinner-content-services-modal" />
        )}
      </ModalTemplate>
    </>
  );
}

const mapStateToProps = ({user, selectedBu, globalStyles, strings}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  globalStyles: globalStyles.value,
  labels: strings.value.pt.services,
});

export default connect(mapStateToProps)(ServiceDetailsModal);
